import type { ProductNodeBuilderProps } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/block/DefaultBlock';
import { DefaultBlockLayout } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/block/DefaultBlock';
import { ProductSummaryFieldsList } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/block/FieldsList';
import { useQuoteWorkspaceContext } from 'contexts/quote-workspace.context';
import type { ReactNode } from 'react';
import { FC } from 'react';
import { connect } from 'react-redux';
import { formProductContainsAssetTypes } from 'state/common-form/commonForm.selectors';
import { hasGreeks } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import { type QuoteWorkspaceType } from 'state/workspaces/model';

type OwnProps = { tabId: string; workspaceType: QuoteWorkspaceType; children: ReactNode };

interface StateProps {
  hasGreeks: boolean;
  isAssetTypeSupported: boolean;
}
type SummarySensitiviesProps = OwnProps & StateProps;
const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  return {
    isAssetTypeSupported: formProductContainsAssetTypes(state, tabId, workspaceType, 'Equity', 'Forex'),
    hasGreeks: hasGreeks(state, workspaceType, tabId),
  };
};

const ConnectedSummarySensitivities = connect(mapStateToProps)(SummarySensitivities);
function SummarySensitivities({ hasGreeks, isAssetTypeSupported, children }: SummarySensitiviesProps) {
  if (!isAssetTypeSupported) {
    return;
  }

  return (
    <>
      {hasGreeks && (
        <DefaultBlockLayout labelKey="quoteDetails.Tab.Greeks" id="greeks">
          {children}
        </DefaultBlockLayout>
      )}
    </>
  );
}
export const SummarySensitivityBlock: FC<ProductNodeBuilderProps> = ({
  node: { properties },
  tabId,
  level,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  const workspace = useQuoteWorkspaceContext();
  return (
    <ConnectedSummarySensitivities tabId={tabId} workspaceType={workspace}>
      <ProductSummaryFieldsList
        level={level}
        nodes={properties}
        tabId={tabId}
        quoteWorkspaceVersion={quoteWorkspaceVersion}
        batchWorkspaceVersion={batchWorkspaceVersion}
        mustForceAdvancedMode={mustForceAdvancedMode}
      />
    </ConnectedSummarySensitivities>
  );
};
